// slides for desktop
import slide1 from '../../assets/about/about_slider/slide-1.svg';
import slide2 from '../../assets/about/about_slider/slide-2.svg';
import slide3 from '../../assets/about/about_slider/slide-3.svg';
import slide4 from '../../assets/about/about_slider/slide-4.svg';
import slide5 from '../../assets/about/about_slider/slide-5.svg';
import slide6 from '../../assets/about/about_slider/slide-6.svg';
import slide7 from '../../assets/about/about_slider/slide-7.svg';
import slide8 from '../../assets/about/about_slider/slide-8.svg';

// slides for 4k
import slide4k1 from '../../assets/about/about_slider_4k/slide4k-1.svg';
import slide4k2 from '../../assets/about/about_slider_4k/slide4k-2.svg';
import slide4k3 from '../../assets/about/about_slider_4k/slide4k-3.svg';
import slide4k4 from '../../assets/about/about_slider_4k/slide4k-4.svg';

// constants for maping
export const arrayOfSlidesForDesktop = [
  slide1, slide2,
  slide3, slide4,
  slide5, slide6,
  slide7, slide8,
];
export const arrayOfSlidesFor4k = [slide4k1, slide4k2, slide4k3, slide4k4];
